<div class="flex align-items-center inline-flex">
  <span *ngIf="supplierOperationalData != null">{{ supplierOperationalData.classification }}</span>
  <img
    *ngIf="supplierOperationalData != null && supplierOperationalData.isTransporter"
    src="assets/images/transported_active.png"
    class="operational-data-transporter"
    style="height: 20px; margin-left: 7px"
    pTooltip="This supplier has transporter capability"
  />
  <span
    *ngIf="supplierOperationalData != null && supplierOperationalData.classification == 'Plated'"
    class="plated-logo"
    >PLATED</span
  >
  <span *ngIf="supplierOperationalData != null && supplierOperationalData.classification == 'New'">
    <span class="star">
      <span class="greenstar">
        <i class="fa fa-star"></i>
      </span>
    </span>
  </span>
  <span
    *ngIf="
      supplierOperationalData != null && supplierOperationalData.classification == 'Operational'
    "
  >
    <span class="star">
      <span class="goldstar">
        <i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i>
      </span>
    </span>
  </span>
</div>
